import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";

import { type DocumentStatusPillVariant } from "../components/StatusPill";

export const WORKER_REQUIREMENT_STATUS_PILL_VARIANTS: Record<
  WorkerRequirementStatus,
  DocumentStatusPillVariant | undefined
> = {
  [WorkerRequirementStatus.APPROVED]: "approved",
  [WorkerRequirementStatus.IN_REVIEW]: "in_review",
  [WorkerRequirementStatus.REJECTED]: "rejected",
  [WorkerRequirementStatus.EXPIRED]: "expired",
  [WorkerRequirementStatus.EXPIRING]: "expiring_soon",
  [WorkerRequirementStatus.MISSING]: undefined,
};

export const QUICK_SIGN_TEXT = "Quick Sign";
export const QUICK_SIGN_TEXT_WITH_LIGHTING_EMOJI = "Quick Sign ⚡";

export const DOCUMENTS_PAGE_SCROLL_POSITION_KEY = "documents-page-scroll-position";
export const DOCUMENTS_LIST_CONTAINER_ID = "documents-list-container";
